import { MarkedTypeEnum } from '@doltech/utils/lib/constants';
import { Path, Point, Range } from 'slate';

export const EDITABLE_BLANK_VOID = 'editable-blank-void';
export interface BlankVoidItem {
  range?: Path | Point | Range;
  blankIndex?: number;
  blankId?: string;
  markedStatus?: MarkedTypeEnum;
}

export interface EditableVoidPluginOptions {
  blanks?: BlankVoidItem[];
  questionNo?: number;
  readOnly?: boolean;
  mode?: string;
  userAnswers?: any[];
  selectBlankIndex?: number;
  withDot?: boolean;
  noArrow?: boolean;
  showBlankBackground?: boolean;
  withQuestionNoOutsideBlankBlock?: boolean;
  onUserAnswerChange?: ({ blankId, text }: { blankId: string; text: string }) => void;
  onClickBlank?: (questionNo, isScroll) => void;
}
